module.exports = __webpack_public_path__ + "img/character-grandpa-content.17b65cec.svg";